module.exports = __webpack_public_path__ + "static/media/ux-fundomate-persona-kate@2x.dead142f.png";